import { cobrandV2APIClient as api } from '@/common/api/cobrandApiClient'

export const FETCH_ACCRUALS_START = 'FETCH_ACCRUALS_START'
export const FETCH_ACCRUALS_SUCCESS = 'FETCH_ACCRUALS_SUCCESS'
export const FETCH_ACCRUALS_ERROR = 'FETCH_ACCRUALS_ERROR'
export const REWRITE_ACCRUALS = 'REWRITE_ACCRUALS'
export const ADD_ACCRUALS = 'ADD_ACCRUALS'
export const FETCH_LAST_ACCRUAL_SUCCESS = 'FETCH_LAST_ACCRUAL_SUCCESS'
export const FETCH_LAST_ACCRUAL_ERROR = 'FETCH_LAST_ACCRUAL_ERROR'

/** Default state for Accruals module */
export const defaultState = {
  accruals: {},
  lastCardsAccrual: {},
  meta: {},
  loading: false,
  errors: null
}

/** Accruals State mutations */
export const mutations = {
  [FETCH_ACCRUALS_START] (state) {
    state.loading = true
    state.meta = { ...defaultState.meta }
  },

  [FETCH_ACCRUALS_SUCCESS] (state, { meta }) {
    state.meta = meta
    state.loading = false
  },

  [REWRITE_ACCRUALS] (state, { cardId, accruals }) {
    state.accruals = {
      ...state.accruals,
      [cardId]: accruals
    }
  },

  [ADD_ACCRUALS] (state, { cardId, accruals }) {
    // data with pagination
    const accrualsByCard = state.accruals[cardId]
      ? [...state.accruals[cardId], ...accruals]
      : accruals

    state.accruals = {
      ...state.accruals,
      [cardId]: accrualsByCard
    }
  },

  [FETCH_ACCRUALS_ERROR] (state, errors) {
    state.loading = false
    state.errors = errors
  },

  [FETCH_LAST_ACCRUAL_SUCCESS] (state, { cardId, accruals }) {
    const lastAccrual = accruals && accruals[0] ? { ...accruals[0] } : {}
    state.lastCardsAccrual = {
      ...state.lastCardsAccrual,
      [cardId]: lastAccrual
    }
  },

  [FETCH_LAST_ACCRUAL_ERROR] (state, errors) {
    state.errors = errors
  }
}

/**
 * Fetch accruals by `cardId`
 * @param {ActionContext} context
 * @param {Object} payload
 * @param {Number} payload.cardId
 */
export async function fetchAccruals ({ commit, rootState }, { mergeData = false, cardId, options = {} }) {
  commit(FETCH_ACCRUALS_START)
  try {
    const accountId = rootState.auth.user.id
    const result = await api.fetchAccruals(accountId, cardId, options)
    commit(FETCH_ACCRUALS_SUCCESS, { cardId, mergeData, ...result })

    const setAction = mergeData ? ADD_ACCRUALS : REWRITE_ACCRUALS
    commit(setAction, { cardId, ...result })
  } catch (error) {
    commit(FETCH_ACCRUALS_ERROR, error)
    throw error
  }
}

/**
 * Fetch last accrual by card id
 * @param {ActionContext} context
 * @param cardId
 * @returns {Promise<void>}
 */
export async function fetchLastAccrualByCard ({ commit, rootState }, cardId) {
  try {
    const accountId = rootState.auth.user.id
    const queryParams = {
      filter: { accrual_group: 'virtual_currency' },
      page: { limit: 1 }
    }
    const result = await api.fetchAccruals(accountId, cardId, { ...queryParams })
    commit(FETCH_LAST_ACCRUAL_SUCCESS, { cardId, ...result })
  } catch (error) {
    commit(FETCH_LAST_ACCRUAL_ERROR, error)
  }
}

/**
 * Accruals State Vuex module
 */
export default {
  namespaced: true,
  state: { ...defaultState },
  mutations,
  actions: {
    fetchAccruals,
    fetchLastAccrualByCard
  }
}
